import { render } from "./FileUploader.vue?vue&type=template&id=f3795a4c"
import script from "./FileUploader.vue?vue&type=script&lang=js"
export * from "./FileUploader.vue?vue&type=script&lang=js"
script.render = render

export default script